import { createSlice } from "@reduxjs/toolkit";

export const editDoorSlice = createSlice({
    name:"editDoor",
    initialState: {
        showEditDoorModal:false,
        selectedDoor:null,
    },
    reducers:{
        setShowEditDoorModal: (state) => {
            state.showEditDoorModal = !state.showEditDoorModal;
        },
        setSelectedDoor: (state, action)=> {
            state.selectedDoor = action.payload;
        },
        resetEditDoor: (state)=> {
            state.showEditDoorModal = false;
            state.selectedDoor = null;
        },
    }
});

export const { setShowEditDoorModal, setSelectedDoor, resetEditDoor } = editDoorSlice.actions;

export default editDoorSlice.reducer;